var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIsolationMode(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 519,
    height: 831,
    viewBox: "0 0 519 831",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.15,
    clipPath: "url(#clip0_483_1775)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M519.372 380.872V311.616H450.128V242.372H380.884V311.616H311.628V380.872H242.384V450.116H311.628V519.36H380.884V588.616H450.128V519.36H519.372V450.116H588.616V380.872H519.372ZM450.128 484.744H380.884V346.244H450.128V484.744Z",
    fill: "#ED1C24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.5 380.872H103.872V450.128H138.5V380.872Z",
    fill: "#ED1C24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.6279 380.872H0V450.128H34.6279V380.872Z",
    fill: "#ED1C24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.884 242.372H34.6279V311.628H103.884V242.372Z",
    fill: "#ED1C24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.128 173.128H103.872V242.384H173.128V173.128Z",
    fill: "#ED1C24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.384 103.872H173.128V173.128H242.384V103.872Z",
    fill: "#ED1C24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.628 34.6279H242.372V103.884H311.628V34.6279Z",
    fill: "#ED1C24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.628 727.128H242.372V796.384H311.628V727.128Z",
    fill: "#ED1C24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.384 657.872H173.128V727.128H242.384V657.872Z",
    fill: "#ED1C24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.5 692.5H103.872V727.128H138.5V692.5Z",
    fill: "#ED1C24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.128 588.628H103.872V657.884H173.128V588.628Z",
    fill: "#ED1C24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.884 519.372H34.6279V588.628H103.884V519.372Z",
    fill: "#ED1C24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.291 104.845H311.663V137.527H346.291V104.845Z",
    fill: "#ED1C24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.5 103.872H103.872V138.5H138.5V103.872Z",
    fill: "#ED1C24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M519.384 173.128H484.756V207.756H519.384V173.128Z",
    fill: "#ED1C24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.256 623.256H311.628V657.884H346.256V623.256Z",
    fill: "#ED1C24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M519.384 692.5H484.756V727.128H519.384V692.5Z",
    fill: "#ED1C24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M450.14 761.756H380.884V831.012H450.14V761.756Z",
    fill: "#ED1C24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M450.14 0H380.884V69.2559H450.14V0Z",
    fill: "#ED1C24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.5 380.872H103.872V450.128H138.5V380.872Z",
    fill: "#ED1C24"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_483_1775"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 831,
    height: 831,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIsolationMode);
export default __webpack_public_path__ + "static/media/Isolation_Mode.1aa1d748ab305abe360a10d9f88053da.svg";
export { ForwardRef as ReactComponent };